import { useState } from 'react';
//mui
import { Box, Stack, Button, TextField } from '@mui/material';
import 'dayjs/locale/ko';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'

import NumberFormatText from '../../common/form/NumberFormatText';
import { getEndDay, selectMonth, today } from '../../../utils/calcDatetime';
import AskDialog from '../../../components/common/dialog/AskDialog';

const AutoBillForm = ({ onAutoBtn, onCancle }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');

  const [reqCompDt, setReqCompDt] = useState(today);
  const [invTxtBefore, setInvTxtBefore] = useState('');
  const [invTxtAfter, setInvTxtAfeter] = useState('');

  const nextLastDay = getEndDay(selectMonth(today, 1));
  const [prodCompDt, setProdCompDt] = useState(nextLastDay);
  const [buyDiv, setBuyDiv] = useState(1);

  const handleCancle = () => {
    setReqCompDt(today);
    setInvTxtBefore('');
    setInvTxtAfeter('');
    setProdCompDt(nextLastDay);
    setBuyDiv(1);
    onCancle();
  };

  const validChk = () => {
    if (reqCompDt === null || reqCompDt === '') {
      setMessage('매입일자를 입력하세요');
      setVisible(true);
      return;
    }

    if (prodCompDt === null || prodCompDt === '') {
      setMessage('지급일자를 입력하세요');
      setVisible(true);
      return;
    }

    if (buyDiv === null || buyDiv === '') {
      setMessage('분할 횟수를 입력하세요');
      setVisible(true);
      return;
    }

    if (Number(buyDiv) < 1) {
      setMessage('분할 횟수는 1 이상이어야 합니다.');
      setVisible(true);
      return;
    }

    return true;
  };

  const handleAutoBtn = () => {
    const valid = validChk();

    if (valid) {
      const data = {
        reqCompDt,
        invTxtBefore,
        invTxtAfter,
        prodCompDt,
        buyDiv,
      };
      onAutoBtn(data);
    }
  };

  return (
    <>
      <Stack direction="row" spacing={2} sx={{ my: 1 }} justifyContent="center">
        <Box sx={{ width: 160 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="reqCompDt"
              name="reqCompDt"
              label="매입일자"
              value={dayjs(reqCompDt)}
              onChange={(newValue) => {
                setReqCompDt(dayjs(newValue));
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  fullWidth: true,
                  size: "small",
                  required: true,
                },
              }}
            />
          </LocalizationProvider>
        </Box>
        <Box sx={{ width: 180 }}>
          <TextField
            id="invTxtBefore"
            label="매입내용 이전"
            variant="outlined"
            size="small"
            value={invTxtBefore}
            onChange={(e) => setInvTxtBefore(e.target.value)}
          />
        </Box>
        <Box sx={{ width: 180 }}>
          <TextField
            id="invTxtAfter"
            label="매입내용 이후"
            variant="outlined"
            size="small"
            value={invTxtAfter}
            onChange={(e) => setInvTxtAfeter(e.target.value)}
          />
        </Box>
        <Box sx={{ width: 180 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="prodCompDt"
              name="prodCompDt"
              label="지급예정일자"
              value={dayjs(prodCompDt)}
              onChange={(newValue) => {
                setProdCompDt(dayjs(newValue));
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  fullWidth: true,
                  required: true,
                  size: "small",
                },
              }}
            />
          </LocalizationProvider>
        </Box>
        <Box sx={{ width: 100 }}>
          <TextField
            size="small"
            required
            variant="outlined"
            fullWidth
            id="buyDiv"
            name="buyDiv"
            label="분할 횟수"
            value={buyDiv}
            onChange={(e) => {
              setBuyDiv(e.target.value);
            }}
            InputProps={{
              inputComponent: NumberFormatText,
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            color="default"
            sx={{ mx: 1 }}
            onClick={handleCancle}
          >
            닫기
          </Button>
          <Button variant="contained" color="warning" onClick={handleAutoBtn}>
            적용
          </Button>
        </Box>
      </Stack>
      <AskDialog
        visible={visible}
        title="등록 오류"
        description={message}
        onCancle={() => setVisible(false)}
        onConfirm={() => setVisible(false)}
      />
    </>
  );
};

export default AutoBillForm;
